import type { IIlluminator } from '@/engine/app/interfaces';
import * as THREE from 'three';

export class Illuminator implements IIlluminator {
  private readonly _ambientLightIntensity: number = Math.PI;

  private readonly _directionalLightIntensity: number = 0.7 * Math.PI;

  private readonly _ambientLight: THREE.AmbientLight;

  private readonly _directionalLight: THREE.DirectionalLight;

  public constructor() {
    this._ambientLight = new THREE.AmbientLight(0x444444, this._ambientLightIntensity);
    this._directionalLight = new THREE.DirectionalLight(0xffffff, this._directionalLightIntensity);
    this._directionalLight.position.set(0, -1, 0.5).normalize();
    this._directionalLight.castShadow = true;
    this._directionalLight.shadow.camera.visible = false;
    const d = 1;
    this._directionalLight.shadow.camera.left = -d;
    this._directionalLight.shadow.camera.right = d;
    this._directionalLight.shadow.camera.top = d;
    this._directionalLight.shadow.camera.bottom = -d;
    this._directionalLight.shadow.camera.near = 1;
    this._directionalLight.shadow.camera.far = 40;
    this._directionalLight.shadow.bias = -0.005;
  }

  public setOrientation(topVector: THREE.Vector3, directionVector: THREE.Vector3): void {
    this._directionalLight.position
      .set(-directionVector.x, -directionVector.y, -directionVector.z)
      .add(topVector.clone().divideScalar(2));
  }

  public getLight(): THREE.DirectionalLight {
    return this._directionalLight;
  }

  public getAmbientLight(): THREE.AmbientLight {
    return this._ambientLight;
  }
}
